import { ConfigProvider } from 'antd';
import { darkTheme } from '@lib/themes';
import React from 'react';
export const DarkTheme = ({ children }) => React.createElement(ConfigProvider, { theme: darkTheme }, children);
